{
  "title": "What's happening in {town}",
  "lead": "Schedules, programs and announcements from every office, in one place.",
  "emergencyModeOn": "Emergency mode is on. See advisories and the nearest evacuation site.",
  "nearestSite": "Nearest site",
  "quickActions": "Quick links",
  "qaMap": "Evacuation map",
  "qaHotlines": "Hotlines",
  "qaCrop": "Crop damage",
  "feedTitle": "Posts",
  "tabAll": "All",
  "tabForYou": "For you",
  "openCalendar": "Calendar",
  "searchLabel": "Search posts",
  "searchPlaceholder": "Search posts or offices",
  "clearSearch": "Clear search",
  "filters": "Filters",
  "filtersCount": "Filters ({count})",
  "activeFilters": "Active filters",
  "removeFilter": "Remove filter: {name}",
  "filterOffice": "Office",
  "filterBarangay": "Barangay",
  "filterCategory": "Category",
  "allOffices": "All offices",
  "allCategories": "All categories",
  "applyFilters": "Show results",
  "clearFilters": "Clear filters",
  "openForRegistration": "Open for registration",
  "onlyFollowed": "Following only",
  "yourBarangay": "Your barangay",
  "yourBarangayHint": "Posts for your barangay appear first. Saved on this phone only.",
  "emptyTitle": "Nothing posted yet",
  "emptyBody": "When offices post schedules, programs and announcements, they appear here.",
  "emptyFilteredTitle": "No posts match",
  "emptyFilteredBody": "Try another search or remove some filters.",
  "forYouSignInTitle": "Your own feed",
  "forYouSignInBody": "Sign in and follow offices, barangays or topics to see their posts here and get notified.",
  "forYouEmptyTitle": "You're not following anything yet",
  "forYouEmptyBody": "Follow the offices, barangays and topics you care about. Their posts will show up here.",
  "forYouQuietTitle": "Nothing new from what you follow",
  "forYouQuietBody": "The offices and topics you follow have no current posts. Check the All tab, or follow more.",
  "chooseFollows": "Choose what to follow",
  "calendarLead": "Every schedule, program and activity by date.",
  "calendarView": "Calendar view",
  "view_month": "Month",
  "view_week": "Week",
  "view_list": "List",
  "prevMonth": "Previous month",
  "nextMonth": "Next month",
  "prevWeek": "Previous week",
  "nextWeek": "Next week",
  "backToToday": "Back to today",
  "eventsCount": "{count} scheduled",
  "noEvents": "Nothing scheduled.",
  "allDay": "All day",
  "addToCalendarFor": "Add {title} to your calendar",
  "listRange": "The next {weeks} weeks.",
  "calendarEmpty": "Nothing scheduled",
  "calendarEmptyBody": "No schedules or programs in the next {weeks} weeks match these filters.",
  "urgentTitle": "Urgent alerts"
}
